import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { createPurchaseRequestor } from "../../../../common/services/purchaseRequestor.api";
import { IEmployee } from "../../../../types/employee.type";
import ComboBoxFormik from "../../../../common/components/form/ComboBoxFormik";
import { getAllEmployees } from "../../../../common/services/employee.api";

type Props = {
  onClose?: () => void;
};

export default function ModalCreatePurchaseRequestor(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const [loading, setLoading] = useState(false);
  const handleCloseModal = () => {
    props.onClose && props.onClose();
  };
  const [employees, setEmployees] = useState<IEmployee[]>([]);

  const initialValues = {
    description: "",
    categoriesId: [],
    employees: [],
    canViewAllOrders: false,
  };

  useEffect(() => {
    async function loadEmployees() {
      const result = await getAllEmployees();
      setEmployees(result.data);
    }
    loadEmployees();
  }, []);

  const formik = useFormik({
    initialValues,
    onSubmit: async (data) => {
      setLoading(true);
      const payload = {
        ...data,
        permissions: {
          canViewAllOrders: data.canViewAllOrders,
        },
      };
      const result = await createPurchaseRequestor(payload);
      if (!result.ok && result.message) {
        notifyError(result.message);
      }
      setLoading(false);
      notifySuccess("Criado Solicitante com sucesso.");
      handleCloseModal();
    },
  });

  return (
    <Modal
      className="relative text-black"
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="text-black dark:text-black">
        <h2 className="text-black">{"Novo Solicitante"}</h2>
      </Modal.Header>
      <Modal.Body className="text-black dark:text-black">
        <FormikProvider value={formik}>
          <ComboBoxFormik
            name="employees"
            label="Selecione o Colaborador"
            options={[
              { label: "", value: "" },
              ...employees.map((employee) => ({
                label: employee.name,
                value: employee._id as string,
              })),
            ]}
            onChange={(value) => {
              const employee = employees.find(
                (employee) => employee._id === value
              );
              formik.setFieldValue("name", employee?.name);
              formik.setFieldValue("employeeId", employee?._id);
              formik.setFieldValue("employeeEmail", employee?.email);
              formik.setFieldValue("companyId", employee?.companyId);
            }}
          ></ComboBoxFormik>
          <div className="mt-4 flex items-center gap-2">
            <input
              id="canViewAllOrders"
              type="checkbox"
              {...formik.getFieldProps("canViewAllOrders")}
              checked={formik.values.canViewAllOrders}
              className="w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500"
            />
            <label htmlFor="viewAll" className="text-sm">
              Visualizar todas ordens de compra
            </label>
          </div>
        </FormikProvider>
        <div className="containerButtonCategory">
          <ButtonWithLoader isLoading={loading} onClick={formik.handleSubmit}>
            Cadastrar
          </ButtonWithLoader>
        </div>
      </Modal.Body>
    </Modal>
  );
}
